import React, { useState, useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
//Material
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
//Component
import { Modal } from "../../stories/modal";
import FormInput from "../../stories/hook-controls/input";
import { ReactTable } from "../../stories/react-table";
//Function
import { setDataToFormHookV2, isEmptyStr } from "../../utils/common-function";
import { formatDateTime } from "../../utils/common-function"
import { getHistoryColumns } from "./columns/export-history";
import { TextField, Divider } from "@material-ui/core";


function ViewDetail(props) {
  const { open } = props;
  const { Detail, ...otherprops } = props;

  const method = useForm();
  const { setValue } = method;

  useEffect(() => {
    if (!open) return;
    if (typeof Detail === "undefined") return;

    let data = setDataToFormHookV2(Detail);
    //console.log(data);
    setTimeout(() => data?.forEach(({ name, value }) => {
      //console.log(name);
      
    if(name === "EXPORT_STATUS"){
      let newStatus = (value === "SUCCESS" || value === "ERROR") ? value : "Running";
      setValue(name, newStatus);
    }
    else{
      setValue(name, value);
    }
    }));
    //console.log(setValue);
  }, [Detail, setValue, open]);

  return (
    <Modal
      {...otherprops}
      hiddenSave={true}
      title="View Export Detail"
      maxWidth={false}
    >
      <FormProvider {...method}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Box flexGrow={1} className="box-input">
              <FormInput
                InputProps={{
                  readOnly: true,
                }}
                variant="filled"
                name="EXPORT_ID"
                label="EXPORT ID"
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box flexGrow={1} className="box-input">
              <FormInput
                InputProps={{
                  readOnly: true,
                }}
                variant="filled"
                name="HOST_NAME"
                label="HOST NAME"
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box flexGrow={1} className="box-input">
              <FormInput
                InputProps={{
                  readOnly: true,
                }}
                variant="filled"
                name="EXPORT_STATUS"
                label="STATUS"
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box flexGrow={1} className="box-input">
              <TextField
                id="outlined-textarea"
                name="ERROR_MESSAGE"
                label="ERROR MESSAGE "
                multiline
                variant="filled"
                rows={10}
                fullWidth
                disabled={true}
                value={Detail?.ERROR_MESSAGE ?? ""}
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box flexGrow={1} className="box-input">
              <TextField
                id="outlined-textarea"
                name="QUERY"
                label="Query "
                //placeholder="Sql query here ..."
                multiline
                variant="filled"
                rows={25}
                fullWidth
                disabled={true}
                value={Detail?.QUERY}
              />
            </Box>
          </Grid>
        </Grid>
      </FormProvider>
    </Modal>
  );
}
export default ViewDetail;
